import { NgModule } from '@angular/core';
import { HeaderThemesComponent } from './header-themes.component';
import { HeaderTheme1Component } from './features/header-theme1/header-theme1.component';
import { HeaderComponent } from './features/components/header/header.component';
import { HeaderTwoComponent } from './features/components/header-two/header-two.component';
import { HeaderOneResComponent } from './features/header-theme2/header-one/header-one.component';
import { HeaderTwoResComponent } from './features/header-theme2/header-two/header-two.component';
import { HeaderTheme2Component } from './features/header-theme2/header-theme2.component';
import { StoreModule } from '@ngrx/store';
import { HeaderReducer } from './domain/facades/store/HeaderThemes.reducers';
import { EffectsModule } from '@ngrx/effects';
import { HeaderEffect } from './domain/facades/store/HeaderThemes.effects';
import { environment } from '../environments/environment';
import { NotificationsComponent } from './features/components/notifications/notifications.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AppProductNamePipe } from './domain/core/pipes/app-product-name.pipe';
import { PriceRoundPipe } from './domain/core/pipes/price-round.pipe';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BranchesModalComponent } from './features/components/branches-modal/branches-modal.component';
import { QuickCartTheme1Component } from './features/components/quickCart/theme1/theme1.component';
import { SkeltonComponent } from './features/components/quickCart/skelton/skelton.component';
import { BranchesModalCellComponent } from './features/components/branches-modal-cell/branches-modal-cell.component';
import { LanguagePipe, LanguageService, SharedModule } from 'imakeapp-shared';
import { HeaderMobileTheme1Component } from './features/header-mobile-theme1/header-mobile-theme1.component';
import { SignInModalComponent } from './features/components/sign-in-modal/sign-in-modal.component';
import { SignUpModalComponent } from './features/components/sign-up-modal/sign-up-modal.component';
import { MobileSearchViewComponent } from './features/components/mobile-search-view/mobile-search-view.component';
import { BaseHeaderComponenetComponent } from './lib/features/base-header-componenet/base-header-componenet.component';
import { AddToCartMobileBarComponent } from './features/components/quickCart/add-to-cart-mobile-bar/add-to-cart-mobile-bar.component';





@NgModule({
  declarations: [
    HeaderThemesComponent,
    HeaderTheme1Component,
    HeaderComponent,
    HeaderTwoComponent,
    HeaderOneResComponent,
    HeaderTwoResComponent,
    HeaderTheme2Component,
    NotificationsComponent,
    AppProductNamePipe,
    PriceRoundPipe,
    BranchesModalComponent,
    QuickCartTheme1Component,
    SkeltonComponent,
    AddToCartMobileBarComponent,
    BranchesModalCellComponent,
    HeaderMobileTheme1Component,
    SignInModalComponent,
    SignUpModalComponent,
    MobileSearchViewComponent,
    BaseHeaderComponenetComponent
  ],
  imports: [

    SharedModule,
    NzSpinModule,
    LazyLoadImageModule,


    StoreModule.forFeature('header_themes', HeaderReducer),
    EffectsModule.forFeature([ HeaderEffect ]),

  ],
  exports: [
    HeaderThemesComponent,
    HeaderMobileTheme1Component
  ],
  providers: [ NzMessageService ,   LanguagePipe ]
})
export class HeaderThemesModule { }
